var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9915 1H4.9985C3.33933 1 2 2.34 2 4V20C2 21.66 3.33933 23 4.9985 23H14.9935C15.2534 23 15.5032 22.9 15.7031 22.71L16.7026 21.71L21.7001 16.71C21.7901 16.62 21.8701 16.51 21.92 16.38C21.97 16.26 22 16.13 22 16V4C22 2.34 20.6607 1 19.0015 1H18.9915ZM15.993 19.59V18C15.993 17.45 16.4428 17 16.9925 17H18.5817L15.993 19.59ZM19.991 5V15H16.9925C15.3333 15 13.994 16.34 13.994 18V21H4.9985C4.44878 21 3.999 20.55 3.999 20V4C3.999 3.45 4.44878 3 4.9985 3H18.9915C19.5412 3 19.991 3.45 19.991 4V5Z",
    fill: "#808D96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7181 7.28193C14.3422 6.90602 13.7349 6.90602 13.359 7.28193L12 8.64096L10.641 7.28193C10.2651 6.90602 9.65783 6.90602 9.28193 7.28193C8.90602 7.65783 8.90602 8.26506 9.28193 8.64096L10.641 10L9.28193 11.359C8.90602 11.7349 8.90602 12.3422 9.28193 12.7181C9.65783 13.094 10.2651 13.094 10.641 12.7181L12 11.359L13.359 12.7181C13.7349 13.094 14.3422 13.094 14.7181 12.7181C15.094 12.3422 15.094 11.7349 14.7181 11.359L13.359 10L14.7181 8.64096C15.094 8.26506 15.094 7.65783 14.7181 7.28193Z",
    fill: "#808D96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default __webpack_public_path__ + "static/media/file_error.e1c0a0cbf273c6d1c97f9d566c07b118.svg";
export { ForwardRef as ReactComponent };